import '../DataCollection.css';
import {useForm} from "react-hook-form";

// This input is like a text input, but it only allows numbers on Blur
// It will allow non-numbers during typing, but will convert the value to a number on blur
const NumberInput = ({
                         label,
                         placeholder,
                         value,
                         name,
                         state,
                         validationRules,
                         onChange,
                         onlyAllowPositive,
                         onlyAllowInteger,
                         validationCallback = undefined,
                         annotationIcon,
                         annotationIconRight,
                         ...rest
                     }) => {
    const {setValue, register, handleSubmit, watch, formState: {errors}} = useForm({mode: 'onBlur'});

    if (state) {
        value = state[name];
    }
    let errorClass = errors[name] ? 'error' : '';

    if (validationRules) {
        validationRules = (validationRules[state] || {})[name] || validationRules;
    }

    const _onBlur = (e) => {

        let stringValue = e.target.value;

        if (validationCallback) {
            stringValue = validationCallback(stringValue);
        }

        let numericalValue = +(stringValue);
        if (isNaN(numericalValue)) {
            numericalValue = 0;
        }

        if (onlyAllowPositive && numericalValue < 0) {
            numericalValue = Math.abs(numericalValue);
        }

        if (onlyAllowInteger) {
            numericalValue = Math.floor(numericalValue);
        }


        //Converts the value to a numeric value, or 0 if not a number
        const newEvent = {
            target: {
                name: e.target.name,
                value: numericalValue
            }
        }
        onChange(newEvent);
        setValue(name, numericalValue, {shouldValidate: true});
    }


    /*
    TODO: BY removing this it makes it possible to store a non numeric value in the database... However blur makes it a number
    //TODO: Needed to do this so we could put in decimals.  Need to find a better way to do this?
    const _onChange = (e) => {
        let numericalValue = +(e.target.value);

        if (isNaN(numericalValue)) {
            return;
        }

        const newEvent = {
            target: {
                name: e.target.name,
                value: numericalValue
            }
        }

        onChange(newEvent);
    }

     */

    return (
        <div className={'form-input-area__input '}>
            <label>
                {label && <span>{label} </span>}
                <span className={'annotated-input-container'}>
                    {annotationIcon &&
                        <span className={'input-annotation-icon'}>{annotationIcon}</span>
                    }
                    <input {...register(name, validationRules)}
                           type="text"
                           name={name}
                           placeholder={placeholder}
                           value={value}
                        //onChange={_onChange}
                           onChange={onChange}
                           onBlur={_onBlur}
                           className={`number ${annotationIcon ? 'annotated-input' : ''} ${annotationIconRight ? 'annotated-input-right' : ''} ${errorClass}`}
                           onFocus={(e) => e.target.select()} // Select text on focus
                           {...rest}
                    />
                    {annotationIconRight &&
                        <span className={'input-annotation-icon-right'}>{annotationIconRight}</span>
                    }
                </span>
                {validationRules && validationRules.required && <span className={'required-input'}>*</span>}
            </label>
        </div>
    )
}

export default NumberInput;